module.exports = __webpack_public_path__ + "44cfb33a22ec97b3ef1081f51102fc23.png";